import { fail, info, success } from "../theme"

export const contract_status: any = {
    "pending": { text: "Aguardando assinatura", color: info },
    "signed": { text: "Assinado", color: success },
    "canceled": { text: "Cancelado", color: fail },
    "refused": { text: "Recusado", color: fail }
}